import {Component, Output, Input, OnDestroy,EventEmitter, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constants } from 'src/app/shared/utils/constants';
import * as moment from 'moment';

@Component({
  selector: 'address-info',
  templateUrl: './address-info.component.html',
  styleUrls: ['./address-info.component.sass'],
})
export class AddressInfoComponent implements OnInit, OnDestroy {
  @Input() addressInfo
  @Input() isEditting
  @Input() showError;
  @Input() childMode = false;
  @ViewChild('form') form: NgForm;
  showAddressDialog = false;
  regexCharacter = Constants.REGEX;
  dateCondition: any = {
    min: null,
    max: new Date(new Date().setFullYear(new Date().getFullYear()-18)),
  };
  validateDob = true;
  countries = {};
  constructor(){
    this.countries = {}
    this.countries = Constants.COUNTRIES.map((c) => {
      return { label: c.name, value: c.code, dialCode: c.dialCode };
    });
  }

  getDate(date){
    return moment(date).format('DD/MM/YYYY')
  }

  validateDateOfBirth(): Boolean{
    if(this.addressInfo.dob > this.dateCondition.max){
      this.validateDob = false
      return false
    }else{
      this.validateDob = true
      return true
    }
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }
}
